<template>
  <div class="swiper-container">
    <div class="swiper-wrapper" :class="{'mousewheel': isMouseWheel}">
      <!-- Slides -->
      <div class="swiper-slide" v-for="img in images">
        <img :src="img" />
      </div>
    </div>
    <div class="swiper-pagination"></div>
  </div>
</template>
<script>
import Swiper from 'swiper';

// core version + navigation, pagination modules:
import SwiperCore, { Navigation, Pagination, Mousewheel } from 'swiper/core';

// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Mousewheel]);
// import Swiper styles
import 'swiper/swiper-bundle.css';

const name = 'Slider'

const props = {
  images: {
    type: Array,
    default () { return [] }
  }
}

function data() {
  return {
    swiperOptions: {
      slidesPerView: 6,
      spaceBetween: 0,
      freeMode: true,
      loop: true,
      mousewheel: {
        eventsTarget: '.swiper-container',
        sensitivity: 2.5
      },
      breakpoints: {
        320: {
          slidesPerView: 3
        },
        768: {
          slidesPerView: 6
        }
      }
    },
    swiperInstance: null,
    isMouseWheel: false,
    mouseWheelTimer: false
  }
}

function mounted() {
  this.swiperInstance = new Swiper(this.$el, this.swiperOptions)
}

function created() {
  window.addEventListener('mousewheel', this.onMouseWheel, false)
  window.addEventListener('DOMMouseScroll', this.onMouseWheel, false)
}

function beforeDestroy() {
  window.removeEventListener('mousewheel', this.onMouseWheel)
  window.removeEventListener('DOMMouseScroll', this.onMouseWheel)
}

function onMouseWheel() {
  const inst = this

  if (inst.mouseWheelTimer) {
    clearTimeout(inst.mouseWheelTimer)
  }

  inst.isMouseWheel = true

  inst.mouseWheelTimer = setTimeout(() => {
    inst.isMouseWheel = false
  }, 250)
}


export default {
  name,
  props,
  data,
  mounted,
  created,
  beforeDestroy,
  methods: {
    onMouseWheel
  }
}

</script>
